
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
const ComponentsBreadcrumb = (props) => {
  const extraBreadcrumbItems = props.breadCrumbList?.map((name, index) => {
    return (
      <Breadcrumb.Item key={name.url}>
        {name.url && <Link to={name.url} className={index === props.breadCrumbList?.length - 1 ? 'breadcrumb-active-item !text-light-textGray dark:text-dark-textGray font-medium' : 'breadcrumb-link font-medium text-light-textGray dark:text-dark-textGray'}>{name.bname}</Link>}
        {!name.url && <p className={index !== props.breadCrumbList?.length - 1 ? 'text-light-textGray dark:text-dark-textGray font-medium' : 'breadcrumb-active-item mb-0 text-light-primaryColor dark:text-dark-primaryColor font-medium'}>{name.bname}</p>}
      </Breadcrumb.Item>

    );
  });
  const breadcrumbItems = [
    <Breadcrumb.Item key="/dashboard"></Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (
    <Breadcrumb separator={<span className='icon bc-arrow' />}>{breadcrumbItems}</Breadcrumb>)
}

export default ComponentsBreadcrumb;